module.exports = __webpack_public_path__ + "img/user_avatar.17568fcd.png";